import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

export function Login() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const error = search.get("error");
  // 24/09/2026: conta bloqueada no RH (auth/google.ts e /auth/sso mandam para
  // /login?erro=bloqueado). Aviso próprio, sem "tente de novo".
  const bloqueado = search.get("erro") === "bloqueado" || error === "bloqueado";

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-brand-50 to-white px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="items-center text-center">
          <img
            src="/logo.png"
            alt="RH Vet Center Miguel"
            className="mb-3 h-20 w-20 rounded-lg object-cover shadow-sm"
          />
          <CardTitle className="text-2xl">RH Vet Center Miguel</CardTitle>
          <CardDescription>Escalas, pagamentos e cadastro da equipe</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {bloqueado && (
            <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              Acesso bloqueado. Fale com a administração.
            </div>
          )}
          {error && !bloqueado && (
            <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              {error === "conta_do_erp"
                ? "Este e-mail já é de uma conta do sistema principal. Entre no ERP da clínica e abra o RH pelo menu Sistemas."
                : error === "oauth"
                ? "Falha no login com Google. Tente novamente."
                : error === "no_user"
                ? "Conta não autorizada. Procure o administrador."
                : "Não foi possível autenticar."}
            </div>
          )}
          <Button asChild size="lg" className="w-full">
            <a href="/api/auth/google">Entrar com Google</a>
          </Button>
          <p className="text-center text-xs text-slate-500">
            Apenas usuários previamente cadastrados podem acessar.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
